module.exports = __webpack_public_path__ + "static/media/ki.bf675826.svg";